<template>
  <router-view v-if="routedVideo" />
  <template v-else>
    <transition-fade :duration="500" appear>
      <div v-if="routedDay" id="calendar-sheet">
        <section
          id="calendar-sheet__section--details"
          class="flex flex-col grow shrink basis-[150px] justify-between items-center"
        >
          <calendar-sheet-meta />
          <calendar-sheet-media />
          <calendar-widget />
        </section>
        <calendar-sheet-image
          class="flex flex-col grow shrink basis-[150px] justify-between items-center"
        />
      </div>
      <div v-else class="flex h-full justify-center items-center">
        <box-generic header="Geen materiaal">
          <p class="leading-relaxed">
            In deze aflevering zijn er geen materialen<br />
            voor het onderdeel “Kalender” beschikbaar.
          </p>
        </box-generic>
      </div>
    </transition-fade>
  </template>
</template>

<script>
import { mapGetters } from "vuex";

import ensureValidDay from "../../../../router/routes/digibord/ensure-valid-day";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import CalendarWidget from "../../../../components/content/season/calendar/CalendarWidget.vue";
import CalendarSheetImage from "../../../../components/content/season/calendar/CalendarSheetImage.vue";
import CalendarSheetMeta from "../../../../components/content/season/calendar/CalendarSheetMeta.vue";
import CalendarSheetMedia from "../../../../components/content/season/calendar/CalendarSheetMedia.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

export default {
  name: "CalendarSheet",
  components: {
    BoxGeneric,
    TransitionFade,
    CalendarSheetMedia,
    CalendarSheetMeta,
    CalendarSheetImage,
    CalendarWidget,
  },
  async beforeRouteEnter(to, from, next) {
    await ensureValidDay(to, next);
  },
  async beforeRouteUpdate(to, from, next) {
    await ensureValidDay(to, next);
  },
  computed: {
    ...mapGetters(["routedDay", "routedVideo"]),
  },
};
</script>

<style scoped lang="css">
#calendar-sheet {
  @apply flex h-[103%] min-h-[calc(100vh_-_12rem)] w-full;
  /* Note `min-h-[calc(100vh_-_12rem)]`: Safari workaround for "height: 100% in flex-item's child" bug: */

  ::v-deep(section) {
    @apply items-center flex grow shrink basis-[150px] flex-col justify-between;

    &#calendar-sheet__section--details {
      /* ... */
    }

    &#calendar-sheet__section--meta {
      @apply basis-[13vh] grow-0;
    }

    &#calendar-sheet__section--media {
      @apply justify-center w-full;
    }

    &#calendar-sheet__section--image {
      @apply grow;
    }
  }
}
</style>
